export default __webpack_public_path__ + "static/logo-f5e5f7a5f98c416203b736ef590e7037.png";